module.exports = __webpack_public_path__ + "media/post-listing-block-2-overlay@2x.fae6fff0.png";